import { PATH } from '../../constants/path.constant';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { coQuyenTraCuuHocVienHienTai } from '../../utils/quyenTraCuu';

function AdminGuard({ children }) {
  // Tap vai nam o `utils/quyenTraCuu` vi man canh bao lich cabin trung cung
  // phai biet — no dung AdminDrivingGuard (rong hon) nhung co nut mo sang
  // trang duoc guard nay gac. Chep tay tap vai sang cho thu hai la de lan sau
  // sua mot ben quen ben kia, va nguoi dung bam vao ngo cut.
  if (coQuyenTraCuuHocVienHienTai()) {
    return children;
  } else {
    return (
      <Navigate
        to={PATH.ADMIN.LOGIN}
        state={{
          from: window.location.pathname,
        }}
        replace={true}
      />
    );
  }
}

export default AdminGuard;
